
// requiring html templates so that hot reloading works
const template = require('./datesSelector.html');

const NS = 'DatesSelector'; // jshint ignore:line

export default function DatesSelector($rootScope, $filter) { // as datesSelector
  "ngInject";

  return {
    bindToController: true,
    controller: function () {},
    controllerAs: 'vm',
    template,
    link,
    restrict: 'E',
    scope: {
      datesArray: '='
    }
  };

  function link($scope) {
    var vm = $scope.vm;
    vm.datesArray = vm.datesArray || [];
    //-- define public methods
    vm.openDatePicker = openDatePicker;
    vm.removeDate = removeDate;
    //-- listeners
    $scope.$watch('vm.addDate', dateChange);

    function openDatePicker(evt) {
      $rootScope.$broadcast('open-date-time-picker', evt, vm, 'addDate', 'date');
    }

    function dateChange(value, oldValue) {
      if (value && value !== oldValue && value instanceof Date) {
        var datesStrArr = vm.datesArray.map(function (date) {
          return $filter('date')(date, 'yyyy-MM-dd');
        });
        var dateStr = $filter('date')(value, 'yyyy-MM-dd');
        if (datesStrArr.indexOf(dateStr) === -1) {
          vm.datesArray.push(value);
        }
      }
    }

    function removeDate(date) {
      var datesStrArr = vm.datesArray.map(function (date) {
        return $filter('date')(date, 'yyyy-MM-dd');
      });
      var dateStr = $filter('date')(date, 'yyyy-MM-dd');
      var dateIndex = datesStrArr.indexOf(dateStr);
      if (dateIndex !== -1) {
        vm.datesArray.splice(dateIndex, 1);
      }

      $rootScope.$broadcast('remove-date', dateStr);
    }
  }
}
